import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import CheckBoxViewModel from '@/ViewModels/Controls/CheckBoxViewModel';

export default class SelectBoxItemViewModel extends ControlViewModel {
    private CheckBoxViewModel = ComponentManager.getViewModel('CheckBoxViewModel');

    /**
     * Beinhaltet den Wert der Option
     */
    public value: KnockoutObservable<string>;

    /**
     * Definiert die CheckBox
     */
    public checkBox: CheckBoxViewModel;

    /**
     * Das ViewModel für den SelectBoxItem
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.value = this.observableOrDefault(params.value, null);
        this.checkBox = this.paramOrDefault(params.checkBox, null);
    }
}

ComponentManager.setViewModel('SelectBoxItemViewModel', SelectBoxItemViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');